import { TOGGLE_MENU } from '../actions/types';

const initialState = {
  list: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_MENU:
      return {
        list: action.payload,
      };
    default: return state;
  }
};
